import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../support/uiStateKeys';

const dataKeys = [
  queryKeys.REMOVE_QUERY_ON_MODAL_CLOSE,
  queryKeys.PROJECT_CODE,
];
/**
 * useProjectCode returns the project code that the user has entered for their download.
 *
 * @returns {{ projectCode: string setProjectCode: function }}
 */
const useProjectCode = () => {
  const queryClient = useQueryClient();
  // useQuery by default returns a data object that represents the value stored in the queryKey
  const { data } = useSuspenseQuery({
    queryKey: dataKeys,
    queryFn: ({ queryKey }) => queryClient.getQueryData(queryKey),
    initialData: null,
  });

  const setProjectCode = (projectCode) => {
    // for data that is not directly bound to an api call we can use teh query client and manually call setQueryData
    queryClient.setQueryData(dataKeys, projectCode);
  };

  return {
    projectCode: data,
    setProjectCode,
  };
};

export default useProjectCode;
